export default __webpack_public_path__ + "static/media/bem.5e52666d.svg";